import Nullstack from 'nullstack';
export default function IconChartArrowsVertical({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-chart-arrows-vertical",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M18 21v-14"
  }), "   ", Nullstack.element("path", {
    d: "M9 15l3 -3l3 3"
  }), "   ", Nullstack.element("path", {
    d: "M15 10l3 -3l3 3"
  }), "   ", Nullstack.element("line", {
    x1: "3",
    y1: "21",
    x2: "21",
    y2: "21"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "21",
    x2: "12",
    y2: "12"
  }), "   ", Nullstack.element("path", {
    d: "M3 6l3 -3l3 3"
  }), "   ", Nullstack.element("path", {
    d: "M6 21v-18"
  }), " ");
}